
import FileInput from "../../../common/input/FileInput";

export default function FieldVideo({ video, onChange }) {
	const hasExisting = typeof video === "string" && Boolean(video);
	return (
		<div className="flex flex-col gap-2">
			<FileInput onChange={onChange} label="ویدئوی معرفی کارگاه" accept="video/*" />
			{hasExisting && (
				<p className="font-Vazir-400 text-[12px] text-darkBlue/50">
					ویدیوی فعلی بارگذاری شده است؛ برای تعویض، فایل جدید انتخاب کنید.
				</p>
			)}
		</div>
	);
}
